export const internalChat = {
  dm: "Mensagem Direta",
  dmDescription: "Inicie uma conversa privada com um membro da equipe.",
  dmDescriptionShort: "Conversa privada 1:1 com um membro da equipe",
  group: "Grupo",
  channel: "Canal",
  channelDescription: "Canais são onde sua equipe se comunica. Eles podem ser organizados por projetos, tópicos ou qualquer outra coisa.",
  channelDescriptionShort: "Canal de grupo para discussões da equipe",
  newDM: "Nova Mensagem Direta",
  newChannel: "Criar Canal",
  selectUser: "Selecionar Usuário",
  groupName: "Nome do Grupo",
  channelName: "Nome do Canal",
  groupNameHelper: "ex: geral, engenharia, marketing",
  channelNameHelper: "ex: geral, engenharia, marketing",
  groupDescriptionLabel: "Descrição",
  channelDescriptionLabel: "Descrição (opcional)",
  descriptionHelper: "Sobre o que é este grupo?",
  visibility: "Visibilidade",
  public: "Público",
  publicHelper: "Qualquer pessoa no workspace pode ver e participar",
  private: "Privado",
  privateHelper: "Apenas membros convidados podem ver e participar",
  addMembers: "Adicionar Membros",
  addMembersHelper: "Você será adicionado automaticamente como dono do canal",
  optional: "opcional",
  searchMembers: "Buscar membros...",
  privateNoMembers: "Você pode adicionar membros agora ou convidá-los depois",
  createChannel: "Criar Canal",
  channelCreated: "Canal criado com sucesso",
  dmCreated: "Conversa iniciada com sucesso",
  directMessages: "Mensagens Diretas",
  channels: "Canais",
  exploreChannels: "Explorar Canais",
  noConversations: "Nenhuma conversa ainda",
  startDM: "Iniciar uma nova mensagem direta",
  startConversation: "Iniciar Conversa",
  noDMs: "Nenhuma mensagem direta",
  noChannels: "Nenhum canal",
  createDM: "Nova mensagem",
  search: "Buscar...",
  editChannel: "Editar Canal",
  editChannelDescription: "Atualize as configurações do canal.",
  invalidChannelName: "Nome do canal só pode conter letras, números, hífens, underscores e espaços",
  channelNameRequired: "Nome do canal é obrigatório",
  addMembersDescription: "Selecione usuários para adicionar a esta conversa.",
  allUsersAdded: "Todos os usuários já estão nesta conversa",
  noUsersFound: "Nenhum usuário encontrado",
  searchUsers: "Buscar por nome ou email...",
  typeToSearch: "Digite para buscar usuários",
  currentMembers: "Membros atuais: %{count}",
  addSelected: "Adicionar %{count} Membro(s)",
  "business-intelligence/pipeline-analysis": {
    name: "Análise de Pipeline |||| Análise de Pipeline",
  },
};
